/**
 * Root route (/) handler.
 * - Vanity city host (unauthenticated): → /advisor (city CitizenAdvisorShell)
 * - Unauthenticated apex: LandingPage
 * - Authenticated: tenant home destination
 */
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import { fetchTenantHomePath, DEFAULT_TENANT_HOME } from '../utils/resolveTenantHome';
import { resolveHostApi } from '../api/applicationType.api';
import Loading from './Loading';

function RootRoute({ darkMode, onToggleTheme }) {
  const tkn = localStorage.getItem('tkn');
  const user = localStorage.getItem('user');
  const signedIn = Boolean(tkn || user);
  const [homePath, setHomePath] = useState(null);
  const [vanityPackageId, setVanityPackageId] = useState(undefined);

  useEffect(() => {
    if (signedIn) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const host = typeof window !== 'undefined' ? window.location.host : '';
        const data = await resolveHostApi(host);
        if (!cancelled) {
          setVanityPackageId(data?.matched && data.packageId ? data.packageId : null);
        }
      } catch (_) {
        if (!cancelled) setVanityPackageId(null);
      }
    })();
    return () => { cancelled = true; };
  }, [signedIn]);

  useEffect(() => {
    if (!signedIn) return undefined;
    let cancelled = false;
    (async () => {
      const path = await fetchTenantHomePath();
      if (!cancelled) setHomePath(path || DEFAULT_TENANT_HOME);
    })();
    return () => { cancelled = true; };
  }, [signedIn]);

  if (!signedIn) {
    if (vanityPackageId === undefined) return <Loading />;
    if (vanityPackageId) return <Navigate to="/advisor" replace />;
    return <LandingPage darkMode={darkMode} onToggleTheme={onToggleTheme} />;
  }

  if (!homePath) {
    return <Loading />;
  }

  return <Navigate to={homePath} replace />;
}

export default RootRoute;
